// extracted by mini-css-extract-plugin
export var addButton = "_ie-0";
export var border = "_ie-8";
export var check = "_ie-h";
export var danger = "_ie-6";
export var dropdownContainer = "_ie-1";
export var editModalBody = "_ie-j";
export var footerContainer = "_ie-i";
export var fullWidth = "_ie-a";
export var hide = "_ie-9";
export var icon = "_ie-3";
export var input = "_ie-7";
export var inputFlex = "_ie-b";
export var inputWrapper = "_ie-c";
export var manualFocus = "_ie-5";
export var optionButton = "_ie-4";
export var pillWrapper = "_ie-e";
export var pointer = "_ie-2";
export var showOverflow = "_ie-f";
export var tagsFlex = "_ie-d";
export var xButton = "_ie-g";